import { render } from "./GradeForm.vue?vue&type=template&id=69be3b2e&scoped=true&bindings={\"addGrade\":\"props\",\"formGrade\":\"data\",\"addgradeFormSubmit\":\"options\"}"
import script from "./GradeForm.vue?vue&type=script&lang=ts"
export * from "./GradeForm.vue?vue&type=script&lang=ts"

import "./GradeForm.vue?vue&type=style&index=0&id=69be3b2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69be3b2e"

export default script